import { Link } from 'react-router';
import { withStyles } from 'tss-react/mui';
import classNames from 'classnames';

interface IProps {
  to: string;
  replace?: boolean;
  disabled?: boolean;
  classes?: Partial<Record<keyof ReturnType<typeof styles>, string>>;
  className?: string;
}

const styles = () => ({
  linkButton: {
    textDecoration: 'none',
    color: 'inherit',
  },
});

/**
 * Gör underliggande element klickbart som en routerlänk för att navigera internet på sidan.
 */
export const RouterLink: React.FC<React.PropsWithChildren<IProps>> = props => {
  const classes = withStyles.getClasses(props);
  return !props.disabled ? (
    <Link
      className={classNames(props.className, classes.linkButton)}
      to={props.to}
      replace={props.replace}
    >
      {props.children}
    </Link>
  ) : (
    <>{props.children}</>
  );
};

export default withStyles(RouterLink, styles);
